import React from 'react';
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import dayjs from 'dayjs';

const FieldHistorySection = ({ fieldHistory, showHistory }) => {
  if (!showHistory) {
    return null;
  }

  return (
    <Box mb={2}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="subtitle2">Field Change History</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            {fieldHistory.length === 0 ? (
              <Typography variant="body2" color="text.secondary">
                No field changes recorded
              </Typography>
            ) : (
              fieldHistory.map((fh, idx) => {
                // Parse nested field changes for better display
                const fieldName = fh.fieldName;
                const isNestedField = fieldName.includes('.') || (typeof fh.oldValue === 'object' && fh.oldValue !== null);
                
                return (
                  <Box key={idx} sx={{ mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                    <Typography variant="subtitle2">
                      Field: {fieldName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Changed by: {fh.changedBy?.firstName || 'Unknown'} {fh.changedBy?.lastName || ''} on {dayjs(fh.changedAt).format('DD MMM YYYY, HH:mm')}
                    </Typography>
                    {fh.remarks && (
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        Remarks: {fh.remarks}
                      </Typography>
                    )}
                    {isNestedField && (
                      <Box sx={{ mt: 1, p: 1, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                        <Typography variant="caption" color="text.secondary">
                          <strong>Old Value:</strong> {typeof fh.oldValue === 'object' ? JSON.stringify(fh.oldValue, null, 2) : String(fh.oldValue || 'N/A')}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                          <strong>New Value:</strong> {typeof fh.newValue === 'object' ? JSON.stringify(fh.newValue, null, 2) : String(fh.newValue || 'N/A')}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                );
              })
            )}
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default FieldHistorySection;

